export function vertexShaderTemplate(
  primitive_type : GLenum,
  attributes     : string,
  uniforms       : string,
  varyings_out   : string,
  chunks         : string,
  logic          : string
): string
{
  const is_triangles = primitive_type === WebGL2RenderingContext.TRIANGLES;
    
  return `#version 300 es
    precision highp float;
    precision highp int;
    precision lowp sampler2D;
    precision lowp sampler2DArray;

    layout(std140) uniform GlobalParams { mat4 u_projection; float u_dpr; float u_time; };

    ${attributes}

    ${uniforms}

    ${varyings_out}

    ${chunks}

    void main()
    {
      vec2 position = vec2( 0.0 );
      ${is_triangles ? 'vec2 size = vec2( 1.0 );' : 'float size = 1.0;'}
      float angle = 0.0;
      
      ${is_triangles ? `
      int idx = gl_VertexID % 6;
      vec2 uv = getCornerFromIndex( idx );
      ` : ''}
        
      // ==========================================
      // USER LOGIC INJECTION
      // ==========================================
      ${logic}
      // ==========================================

      ${is_triangles ? `
      vec2 final_world_pos = getVertexFromIndex( idx, position, angle, size );
      gl_Position = u_projection * vec4( final_world_pos, 0.0, 1.0 );
      ` : `
      gl_Position = u_projection * vec4( position, 0.0, 1.0 );
      gl_PointSize = size * u_dpr;
      `}
    }
    `;
};

export function fragmentShaderTemplate(
  uniforms    : string,
  varyings_in : string,
  chunks      : string,
  logic       : string
): string
{
  return `#version 300 es
    precision highp float;
    precision highp int;
    precision lowp sampler2D;
    precision lowp sampler2DArray;

    ${uniforms}

    ${varyings_in}

    ${chunks}

    out vec4 fragColor;

    void main()
    {
      ${logic}
    }
    `;
};
